import * as z from "zod";

export const FlattenedCustomerVariantPreferencesSchema = z.array(
  z.object({
    categoryName: z.string(),
    optionName: z.string(),
    count: z.number(),
  }),
);
export type FlattenedCustomerVariantPreferences = z.infer<
  typeof FlattenedCustomerVariantPreferencesSchema
>;
